export default __webpack_public_path__ + "6a49acccbbbb4226e2c202dee17b8b6d.svg";